import Vue from "vue";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);

// Helper Class to handle JWT within BOLT ecosystem
export default class JwtManager {
  static setCookie(token, expire, secure, sameSite) {
    if (expire === undefined) {
      expire = "365d";
    }
    if (secure === undefined) {
      secure = process.env.NODE_ENV === "production";
    }
    if (sameSite === undefined) {
      sameSite = "Lax";
    }

    Vue.$cookies.set("bolt-token", token, expire, null, JwtManager.getDomain(), secure, sameSite);
  }

  static clearCookie() {
    Vue.$cookies.remove("bolt-token", null, JwtManager.getDomain());
  }

  static getToken() {
    return Vue.$cookies.get("bolt-token");
  }

  static getDomain() {
    // So for PRODUCTION: this will set domain to letsbolt.com.au
    // For STAGINGS: this will set domain to ENV.letsbolt.io
    // For DEV: this should be "web.letsbolt.test"

    let reserveSlices = -3;

    if (window.location.hostname.endsWith(".test")) {
      reserveSlices = -2;
    }

    return window.location.hostname.split(".").slice(reserveSlices).join(".");
  }
}
